export const Header = () => {
  return (
    <header className="md:mt-7 px-4 md:px-5 mb-7 md:mb-16 bg-neutral-800 bg-opacity-70 md:bg-[#fff257]">
      <div className="flex items-center justify-between wrapper">
        <a href="/" id="logo">
          <img className="w-14 lg:w-18 md:scale-[1.8] origin-left" src="/logo.png" alt="IDM" />
        </a>
        <div className="menu px-2">
          <ul className="flex justify-between gap-x-7 lg:gap-x-12 flex-nowrap">
            <li className="py-2 md:py-5">
              <a href="https://idm.ua/about-idm" className="link text-white md:text-neutral-900">Про IDM</a>
            </li>
            <li className="py-2 md:py-5">
              <a href="https://idm.ua" className="link text-white md:text-neutral-900">Основний Сайт</a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  )
}